// start:ng42.barrel
export * from './message-category.model';
export * from './message-type.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/message/index.ts